import React, { FC, Fragment, PropsWithChildren } from 'react';
import {
  Button,
  Divider,
  Modal as DuxtonModal,
  Flex,
  ModalProps,
} from '@duxton-web/ui';

import './Modal.css';

import { CloseUniversal } from '@duxton-web/icons';

interface OwnProps {
  key?: string;
  className?: string;
  hideHeaderDivider?: boolean;
  hideFooterDivider?: boolean;
}

const DEFAULT_MODAL_WIDTH = 700;

export const Modal: FC<PropsWithChildren<OwnProps & ModalProps>> = ({
  key,
  className,
  hideHeaderDivider = false,
  children,
  closable = true,
  title,
  footer,
  onCancel,
  onOk,
  ...others
}) => {
  const renderFooter = () => {
    if (footer === null) return null;

    if (footer)
      return (
        <Fragment>
          {!hideHeaderDivider && <Divider className="title-divider" />}
          <div
            className="footer-container"
            style={{
              paddingTop: hideHeaderDivider ? '0px' : '16px',
            }}
          >
            {typeof footer === 'function'
              ? footer(null, { OkBtn: () => null, CancelBtn: () => null })
              : footer}
          </div>
        </Fragment>
      );

    return (
      <Fragment>
        {!hideHeaderDivider && <Divider className="title-divider" />}
        <div
          className="footer-container"
          style={{
            paddingTop: hideHeaderDivider ? '0px' : '16px',
          }}
        >
          <Flex align="center" justify="flex-end" gap={8}>
            <Button
              size="small"
              {...others.cancelButtonProps}
              onClick={onCancel}
            >
              {others.cancelText || 'Cancel'}
            </Button>
            <Button
              size="small"
              type="primary"
              {...others.okButtonProps}
              onClick={onOk}
            >
              {others.okText || 'Ok'}
            </Button>
          </Flex>
        </div>
      </Fragment>
    );
  };

  return (
    <DuxtonModal
      width={others.width || DEFAULT_MODAL_WIDTH}
      key={key}
      className={`grab-x__modal${className ? ` ${className}` : ''}`}
      closable={title ? false : closable}
      title={
        title && (
          <Fragment>
            <div
              className="title-container"
              style={{
                paddingBottom: hideHeaderDivider ? '0px' : '16px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                {title}
                {closable && <CloseUniversal onClick={onCancel} />}
              </div>
            </div>
            {!hideHeaderDivider && <Divider className="title-divider" />}
          </Fragment>
        )
      }
      footer={renderFooter()}
      {...others}
    >
      {children}
    </DuxtonModal>
  );
};
